import { ContainerModule } from '@evertel/di'
import { DepartmentsAccessStore } from './store'
import { DepartmentsAccessController, SelectedDepartmentAccessController } from './controllers'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(DepartmentsAccessStore).toSelf().inSingletonScope()
        m.bind(DepartmentsAccessController).toSelf()
        m.bind(SelectedDepartmentAccessController).toSelf()
    })
]

export { DI_MODULES }
